export const EMBED_MAX_WIDTH_PX = 768;

export const EMBED_MAX_WIDTHS = {
  largest: EMBED_MAX_WIDTH_PX,
  medium: 500,
} as const;
